<template>
  <RouterView :key="$route.fullPath" />
</template>

<script>
import {
  eventManager,
  HUNT_AREA_MEMBERS_CHANGED_EVENT,
  HUNT_MEMBERS_CHANGED_EVENT,
  GPS_OWNER_CHANGED_EVENT,
  GPS_SUBSCRIPTION_CHANGED_EVENT
} from "@/eventManager.js";

import {
  LOAD_USER_WITH_ID,
  INVALIDATE_HUNT_AREAS,
  INVALIDATE_HUNTS,
  INVALIDATE_GPS_DEVICES
} from "./userStore";

export default {
  name: "UserModule",

  props: {
    userStorePath: {
      type: String,
      required: true
    },

    userId: {
      type: String,
      required: true
    }
  },

  created() {
    const loadUserWithIdAction = `${this.userStorePath}/${LOAD_USER_WITH_ID}`;
    const userId = this.userId;
    this.$store.dispatch(loadUserWithIdAction, { userId });

    // Make sure that hunt areas are reset whenever hunt area members change to prevent stale data.
    eventManager.$on(HUNT_AREA_MEMBERS_CHANGED_EVENT, this.handleHuntAreaMembersChanged);

    // Make sure that hunts are reset whenever hunt members change to prevent stale data.
    eventManager.$on(HUNT_MEMBERS_CHANGED_EVENT, this.handleHuntMembersChanged);

    // Make sure that GPS devices are reset whenever GPS owner change to prevent stale data.
    eventManager.$on(GPS_OWNER_CHANGED_EVENT, this.handleGPSOwnerChanged);

    // Make sure that GPS devices are reset whenever a GPS subscription is transfered to prevent stale data.
    eventManager.$on(GPS_SUBSCRIPTION_CHANGED_EVENT, this.handleGPSSubscriptionChanged);
  },

  beforeDestroy() {
    eventManager.$off(HUNT_AREA_MEMBERS_CHANGED_EVENT, this.handleHuntAreaMembersChanged);
    eventManager.$off(HUNT_MEMBERS_CHANGED_EVENT, this.handleHuntMembersChanged);
    eventManager.$off(GPS_OWNER_CHANGED_EVENT, this.handleGPSOwnerChanged);
    eventManager.$off(GPS_SUBSCRIPTION_CHANGED_EVENT, this.handleGPSSubscriptionChanged);
  },

  methods: {
    handleHuntAreaMembersChanged({ userId }) {
      if (userId !== this.userId) {
        return;
      }

      const resetHuntAreasAction = `${this.userStorePath}/${INVALIDATE_HUNT_AREAS}`;
      this.$store.dispatch(resetHuntAreasAction);
    },

    handleHuntMembersChanged({ memberId }) {
      if (memberId !== this.userId) {
        return;
      }

      const resetHuntsAction = `${this.userStorePath}/${INVALIDATE_HUNTS}`;
      this.$store.dispatch(resetHuntsAction);
    },

    handleGPSOwnerChanged() {
      const resetGPSDevicesAction = `${this.userStorePath}/${INVALIDATE_GPS_DEVICES}`;
      this.$store.dispatch(resetGPSDevicesAction);
    },

    handleGPSSubscriptionChanged() {
      const resetGPSDevicesAction = `${this.userStorePath}/${INVALIDATE_GPS_DEVICES}`;
      this.$store.dispatch(resetGPSDevicesAction);
    }
  }
}
</script>

<style>

</style>
